import { render } from "./EvalvationPrograms.vue?vue&type=template&id=1625afcf"
import script from "./EvalvationPrograms.vue?vue&type=script&lang=js"
export * from "./EvalvationPrograms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__